import React, { useEffect } from 'react';
import { MainTitle, Spinner } from '../../../../common/index.jsx';
import { useGetDissertationsQuery } from '../../../../../redux/services/dissertations.jsx';
import DissertationsTable from './DissertationsTable.jsx';
import { routes } from '../../../../../utils/helpers/ApiClient.jsx';
import CollapseBlock from '../../../../common/blocks/CollapseBlock/CollapseBlock.jsx';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const DissertationsPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    document.title = t('Dizertačné práce');
  }, []); // Runs on mount

  const { data: dissertations, isLoading: isLoadingDissertations } =
    useGetDissertationsQuery();

  return isLoadingDissertations ? (
    <Spinner />
  ) : (
    <CollapseBlock>
      <MainTitle title={t('Dizertačné práce')} />
      <DissertationsTable
        dissertations={dissertations}
        onDetailClick={(dissertation) =>
          navigate(`${routes.dissertationsDetail}/${dissertation.id}`)
        }
      />
    </CollapseBlock>
  );
};

export default DissertationsPage;
